import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
export function ResearchTesting() {
  return <>
      <section className="bg-white py-20 lg:py-28" data-id="element-1258" data-mp="19swputvkfbud">
        <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1259" data-mp="19r24xfkanjqa">
          <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight" data-id="element-1260" data-mp="1iu38p9losyqs">
            How we intend to test the vision
          </h2>
          <div className="lg:col-span-7" data-id="element-1261" data-mp="1sil4fcf40fnk">
            <div className="border-l-4 border-teal pl-6 mb-8" data-id="element-1262" data-mp="1sjmr6e5hmql4">
              <p className="text-sm font-medium text-teal mb-2" data-id="element-1263" data-mp="1xir3hdnpl4fo">First practical milestone</p>
              <p className="text-xl text-ink-dark leading-relaxed" data-id="element-1264" data-mp="22hu6yto1j2lj">
                A narrow, voluntary pilot: define and test one NCJI domain,
                connect its tasks and rubrics through SKP, provide
                understandable feedback, offer development activities, and
                measure change over time.
              </p>
            </div>
            <p className="text-lg text-ink-muted leading-relaxed mb-5" data-id="element-1265" data-mp="2pf0aw1aajimf">
              Later work could test opportunity guidance and institutional
              workflows. Any proposed use that affects eligibility or civic
              standing would need separate validation, independent oversight,
              and functioning review and appeal procedures.
            </p>
            <p className="text-lg text-ink-dark leading-relaxed" data-id="element-1266" data-mp="383x3m0q1i32j">
              SyNeural’s larger vision is to connect knowledge with human
              development: helping researchers discover relationships, helping
              people strengthen judgment, and helping institutions make
              decisions that can be understood and improved.
            </p>
          </div>
        </motion.div>
      </section>

      <section className="bg-navy text-white py-20 lg:py-28" data-id="element-1267" data-mp="3r06gwlt4aplh">
        <motion.div {...fadeUp} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1268" data-mp="1p5s9c3san6oh">
          <h2 className="font-heading font-bold text-4xl lg:text-5xl tracking-tight mb-6" data-id="element-1269" data-mp="1u2sco6xrdvbw">
            Research partnerships
          </h2>
          <p className="text-xl text-white/80 leading-relaxed mb-10" data-id="element-1270" data-mp="1fcte432akhvw">
            We welcome collaboration with researchers, educators, knowledge
            engineers, assessment specialists, and institutions interested in
            testing these ideas.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1271" data-mp="1ahe5pqn1ze6v">
            <a href="/semantic-knowledge" className="inline-flex items-center justify-center gap-2 bg-white text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1272" data-mp="wgv1yvpmeuai">
              Explore SKP
              <ArrowRight size={18} data-id="element-1273" data-mp="2vtfn5i3oev3h" />
            </a>
            <a href="/partnerships" className="inline-flex items-center justify-center border border-white/40 text-white hover:bg-white/10 font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1274" data-mp="2vr32gx6ja6mq">
              Discuss a Research Partnership
            </a>
          </div>
        </motion.div>
      </section>
    </>;
}